import { render, staticRenderFns } from "./IotSensorModelList.vue?vue&type=template&id=1506a0b2&scoped=true&"
import script from "./IotSensorModelList.vue?vue&type=script&lang=js&"
export * from "./IotSensorModelList.vue?vue&type=script&lang=js&"
import style0 from "./IotSensorModelList.vue?vue&type=style&index=0&id=1506a0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506a0b2",
  null
  
)

export default component.exports